module.exports = __webpack_public_path__ + "img/Feature.2583d0b2.jpg";